import { useCallback } from 'react';
import { weeklyScheduleApi } from 'src/Api/weekly-schedule';


const useConstructionSites = () => {
    const updateConstructionSiteHistory = useCallback( async (siteId: number | string | {value: number | string} | (number | string | {value: number | string})[]) => {
        // If we get an array, update the history for each element
        if (Array.isArray(siteId)) {
            siteId.map((id) => {
                updateConstructionSiteHistory(id);
            });
            return;
        }

        // Type guard to check if siteId is an object with 'value'
        const hasValueProperty = (obj: any): obj is { value: number | string } => {
            return typeof obj === "object" && obj !== null && "value" in obj;
        };
        if (hasValueProperty(siteId)) { siteId = siteId.value; }

        if (typeof siteId !== "number" && typeof siteId !== "string") return;

        // load the existing history from local storage
        const constructionSiteHistory = JSON.parse(localStorage.getItem("constructionSiteHistory") || "[]");
        const siteIdStr = siteId.toString();

        // remove the siteId from the history if it already exists
        const index = constructionSiteHistory.indexOf(siteIdStr);
        if (index !== -1) {
            constructionSiteHistory.splice(index, 1);
        }

        // add the siteId to the front of the history then save it
        constructionSiteHistory.unshift(siteIdStr);
        localStorage.setItem("constructionSiteHistory", JSON.stringify(constructionSiteHistory));

        // Make the API call to update the construction site position
        try {
            await weeklyScheduleApi.updateConstructionSiteOrder({ construction_site_id: siteIdStr });
        } catch (error) {
            console.error("Failed to update construction site position on the server:", error);
        }
    }, []);

    const sortConstructionSites = useCallback((input) => {
        let constructions;
        let isWrapped = false;

        if (Array.isArray(input)) {
            constructions = input;
        } else if (input && Array.isArray(input.constructions)) {
            constructions = input.constructions;
            isWrapped = true;
        } else {
            return input;
        }

        const constructionSiteHistory = JSON.parse(localStorage.getItem("constructionSiteHistory") || "[]");

        const sortedConstructions = constructions.sort((a, b) => {
            if(!a || !a.id) return 1;
            if(!b || !b.id) return -1;
            const indexA = constructionSiteHistory.indexOf(a.id.toString());
            const indexB = constructionSiteHistory.indexOf(b.id.toString());

            if (indexA === -1 && indexB === -1) {
                return 0;
            }
            if (indexA === -1) {
                return 1;
            }
            if (indexB === -1) {
                return -1;
            }
            return indexA - indexB;
        });

        if (isWrapped) {
            return {
                ...input,
                constructions: sortedConstructions
            };
        } else {
            return sortedConstructions;
        }
    }, []);

    return { updateConstructionSiteHistory, sortConstructionSites };
};

export default useConstructionSites;
